import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "info-card-row" };
const _hoisted_2 = { class: "info-card-row__head" };
const _hoisted_3 = { class: "info-card-row__body" };
const _hoisted_4 = { class: "info-card-row" };
const _hoisted_5 = { class: "info-card-row__head" };
const _hoisted_6 = { class: "info-card-row__body" };
const _hoisted_7 = { class: "info-card-row" };
const _hoisted_8 = { class: "info-card-row__head" };
const _hoisted_9 = { class: "info-card-row__body" };
const _hoisted_10 = { class: "info-card-row" };
const _hoisted_11 = { class: "info-card-row__head" };
const _hoisted_12 = { class: "info-card-row__body" };
const _hoisted_13 = { class: "info-card-row" };
const _hoisted_14 = { class: "info-card-row__head" };
const _hoisted_15 = { class: "info-card-row__body" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_card_text = _resolveComponent("v-card-text");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.isOpen,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.isOpen) = $event)),
        "content-class": "modal",
        width: "500"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                        icon: "mdi-close",
                        variant: "text",
                        class: "btn-close",
                        onClick: _ctx.handleClickCloseBtn
                    }, null, 8 /* PROPS */, ["onClick"]),
                    _createVNode(_component_v_card_title, { class: "modal__head" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'worker_detail_info')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_card_text, { class: "modal__body" }, {
                        default: _withCtx(() => [
                            _createCommentVNode(" 일반 정보 "),
                            _createVNode(_component_v_card, {
                                class: "info-card brg-card-outlined",
                                elevation: "0",
                                outlined: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "info-card__head contents-title-text" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'common_info')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_card_text, null, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_1, [
                                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.lc + 'allocated_worker')), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.workerName), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_4, [
                                                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.lc + 'worker_code')), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.workerCode), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(_ctx.lc + 'workerPhoneNumber')), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.workerPhoneWithHypen), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 소속 / 근무 "),
                            _createVNode(_component_v_card, {
                                class: "info-card brg-card-outlined",
                                elevation: "0",
                                outlined: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "info-card__head contents-title-text" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'belongTo')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_card_text, null, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(_ctx.lc + 'belongToDistributor')), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.distributorName), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t(_ctx.lc + 'belongToHub')), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.hubName), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]));
}
